import "./TomeIAlmondHero.css";

/** Owner-supplied panorama; interface copy remains accessible HTML. */
export default function TomeIAlmondHero() {
  return (
    <section className="tome-i-hero" aria-labelledby="tome-i-heading" data-testid="tome-i-hero">
      <picture className="tome-i-hero__art">
        <source media="(max-width: 767px)" srcSet="/almond-book/tome-i-almond-hero-mobile-20261027.webp" width="1200" height="732" />
        <source media="(max-width: 1023px)" srcSet="/almond-book/tome-i-almond-hero-mobile.png" width="1080" height="394" />
        <img src="/almond-book/tome-i-almond-hero-desktop.png" width="1536" height="561"
          alt="" fetchPriority="high" decoding="async" />
      </picture>
      <div className="tome-i-hero__copy">
        <p className="tome-i-hero__brand">ЛАБОРАТОРИЯ ПРЕВРАЩЕНИЙ</p>
        <h1 id="tome-i-heading">Том I «Миндаль»</h1>
        <p className="tome-i-hero__description">Один ингредиент. Десятки превращений.</p>
      </div>
    </section>
  );
}
